/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FormalizedZipFilterRequest } from '../models/FormalizedZipFilterRequest';
import type { FormalizedZipRequestDto } from '../models/FormalizedZipRequestDto';
import type { FormalizedZipResponseDto } from '../models/FormalizedZipResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FormalizedZipControllerService {

    /**
     * @param id
     * @returns FormalizedZipResponseDto OK
     * @throws ApiError
     */
    public static findById(
        id: number,
    ): CancelablePromise<FormalizedZipResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/formalized-zips/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns FormalizedZipResponseDto OK
     * @throws ApiError
     */
    public static update(
        id: number,
        requestBody: FormalizedZipRequestDto,
    ): CancelablePromise<FormalizedZipResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/formalized-zips/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/formalized-zips/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param requestBody
     * @returns FormalizedZipResponseDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: FormalizedZipRequestDto,
    ): CancelablePromise<FormalizedZipResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/formalized-zips',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns FormalizedZipResponseDto OK
     * @throws ApiError
     */
    public static filterFormalizedZips(
        requestBody: FormalizedZipFilterRequest,
    ): CancelablePromise<Array<FormalizedZipResponseDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/formalized-zips/filter',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
